import React from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {DealActivityCreatedItem} from 'yougile-model'
import {Icon} from '@components/common/base/icon'
import {TwMessageContainer} from './common'
import {DealTimeLineMessageProps} from './types'

export const DealTimeLineCreatedMessage = (
  props: DealTimeLineMessageProps<DealActivityCreatedItem>
) => {
  const {activity} = props

  return (
    <TwMessageContainer key={activity.id} $position="center" className="h-32">
      <div className="w-40 flex items-center justify-center">
        <Icon icon="EllipseSystemIcon" />
      </div>
      <div className="text-sm-regular text-primary pl-12">
        <span className="text-secondary">
          {Time.formatDateTime(activity.timestamp)}
        </span>
        <span className="ml-4">
          {Lang.msg.crm.rightPanel.dealHistory.dealCreated}
        </span>
      </div>
    </TwMessageContainer>
  )
}
